import React, { useContext } from 'react';
import { AdminContext } from '../../context/AdminContext';
import splash from '../../../../assets/imgs/login/loginLogo.svg';
import SplashLoader from '../SplashLoader';
import styles from './styles.module.css';
const Splash = ({ content }) => {
  const { themeMode } = useContext(AdminContext);
  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <img
          src={splash}
          width={100}
          height={100}
          className={`${themeMode == 'dark' && 'makeWhite'}`}
        />
        <SplashLoader />
        <p>{content?.splash}</p>
      </div>
    </div>
  );
};
export default Splash;
